module.exports = __webpack_public_path__ + "SLUMEA-SD-Logo.8859a185e61c83f8c64affa1f47059a5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/footer/SLUMEA-SD-Logo.png
// module id = 469
// module chunks = 0